import { fmtMoney } from "@/lib/format";

function MetricCell({ label, value, testId }) {
  return (
    <div className="p-4 border border-canvas-line bg-canvas-card" data-testid={testId}>
      <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-ink-muted mb-2">
        {label}
      </div>
      <div className="font-display text-2xl font-bold text-ink">{value}</div>
    </div>
  );
}

export default function CustomerAnalytics({ analytics }) {
  if (!analytics) return null;
  return (
    <div className="grid grid-cols-3 gap-3">
      <MetricCell
        label="Lifetime Value"
        value={fmtMoney(analytics.total_spent)}
        testId="ltv-total"
      />
      <MetricCell
        label="Deals Closed"
        value={analytics.deal_count}
        testId="ltv-deals"
      />
      <MetricCell
        label="Avg Deal Size"
        value={fmtMoney(analytics.avg_deal)}
        testId="ltv-avg"
      />
    </div>
  );
}
